{
  "areYouSureToDelete": "Are you sure you want to delete this message? This cannot be undone.",
  "ask": "Ask question",
  "cancel": "Cancel",
  "close": "Close",
  "delete": "Delete",
  "deleted": "This message was deleted",
  "edit": "Edit",
  "edited": "(edited)",
  "empty": "No one has posted here yet.<br />Be the first!",
  "errorMessage": "An error has occurred. Please try again later",
  "errorMessageTooLong": "Message is too long. Please shorten it. Extra characters: {{ count }}.<br/>Or use <a href=\"https://pastebin.com/\" target=\"_blank\">pastebin.com</a> and send a link.",
  "hide": "Hide",
  "history": "Message history",
  "isHidden": "Hidden",
  "pin": "Pin",
  "pinned": "Pinned",
  "reply": "Reply",
  "replyCount": "{count, plural, one {# comment} other {# comments}}",
  "save": "Save",
  "show": "Make visible",
  "showAllAnswerText": "Show the full text of answer",
  "showAllQuestionText": "Show the full text of question",
  "showAnswerPreview": "Hide full answer",
  "showQuestionPreview": "Hide full text",
  "submit": "Submit",
  "unpin": "Unpin"
}
